import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { HttpEventType, HttpClient, HttpParams } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class AskApolloService {
  constructor(private http: HttpClient) {}
  getIntegrationValueFromLocalStorage(): string {
    const configValues = localStorage.getItem("generalconfig");

    if (configValues) {
      try {
        const parsed = JSON.parse(configValues);
        const entry = parsed.find(
          (item: any) => item.keyName === "IsThirdPartyIntegration"
        );

        if (entry && entry.keyValue) {
          return entry.keyValue;
        }
      } catch (e) {
        console.error("Error parsing generalconfig from localStorage", e);
      }
    }

    // Default fallback
    return "2";
  }

  getUHIDonMobileorEmail(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/FetchUHIDOnMobileOrEmail/",
      payload
    );
  }

  getAllCities(apptType: any, hospitalType: any) {
    const integrationValue = this.getIntegrationValueFromLocalStorage();
    const params = new HttpParams().set("integration", integrationValue);

    return this.http.get<any>(
      `${environment.apiUrl}AskApollo/FetchCities/${apptType}/${hospitalType}`
    );
  }

  // getAllCities(apptType: any, hospitalType: any) {
  //   return this.http.post<any>(environment.apiUrl + "HMS/GetAllCities", "");
  // }

  getClinicsOnCityId(apptType: any, hospitalType: any, cityId: any) {
    const integrationValue = this.getIntegrationValueFromLocalStorage();
    const params = new HttpParams().set("integration", integrationValue);

    return this.http.get<any>(
      `${environment.apiUrl}AskApollo/FetchClinicsOnCityId/${apptType}/${hospitalType}/${cityId}`,
      { params }
    );
  }

  // getClinicsOnCityId(apptType: any, hospitalType: any, cityId: any) {
  //   return this.http.post<any>(
  //     environment.apiUrl + "HMS/GetAllClinics?cityId=" + cityId,
  //     ""
  //   );
  // }
  getSpecialitiesOnHospitalId(hospitalType: any, hospitalId: any) {
    const integrationValue = this.getIntegrationValueFromLocalStorage();

    const params = new HttpParams().set("integration", integrationValue);

    return this.http.get<any>(
      `${environment.apiUrl}AskApollo/FetchSpecialities/${hospitalType}/${hospitalId}`,
      { params }
    );
  }
  // getSpecialitiesOnHospitalId(hospitalType: any, hospitalId: any) {
  //   return this.http.post<any>(environment.apiUrl + "HMS/GetSpecialities", "");
  // }

  getDoctorsOnSpeciality(hospitalId: any, specialityId: any) {
    const integrationValue = this.getIntegrationValueFromLocalStorage();
    const params = new HttpParams().set("integration", integrationValue);

    return this.http.get<any>(
      `${environment.apiUrl}AskApollo/FetchDoctors/${hospitalId}/${specialityId}`,
      { params }
    );
  }

  // getDoctorsOnSpeciality(hospitalId: any, specialityId: any) {
  //   return this.http.post<any>(
  //     environment.apiUrl +
  //       "HMS/GetAllDoctors?hospitalClinicId=" +
  //       hospitalId +
  //       "&hospitalSpecialityId=" +
  //       specialityId,
  //     ""
  //   );
  // }

  getDates(hospitalId: any, doctorId: any) {
    return this.http.get<any>(
      environment.apiUrl + "AskApollo/FetchDates/" + hospitalId + "/" + doctorId
    );
  }

  // getDates(hospitalId: any, doctorId: any) {
  //   return this.http.post<any>(
  //     environment.apiUrl +
  //       "HMS/GetDoctorAvaialbleDates?center_id=" +
  //       hospitalId +
  //       "&doctor_id=" +
  //       doctorId,
  //     ""
  //   );
  // }

  getDates1(hospitalId: any, doctorId: string, apptDate: string) {
    return this.http.post<any>(
      environment.apiUrl +
        "HMS/GetAvailableSlotsByDate?center_id=" +
        hospitalId +
        "&doctor_id=" +
        doctorId +
        "&appointmentDate=" + // <-- fixed here
        apptDate,
      "" // <-- required empty body
    );
  }

  getSlots(
    hospitalId: any,
    doctorId: string,
    specialityId: any,
    apptDate: any,
    selectedSpeciality: any
  ) {
    // let payload = {
    //   "hospitalId": 311,
    //   "doctorId": 970620,
    //   "specialityId": 259,
    //   "appointmentDate": "25-04-2020",
    //   "adminModulesRequest":true,
    //   "isAngularRequest": true
    //   }
    debugger;
    let payload = {
      hospitalId: hospitalId,
      doctorId: doctorId,
      specialityId: selectedSpeciality==""?specialityId:selectedSpeciality,
      appointmentDate: apptDate,
      adminModulesRequest: true,
      isAngularRequest: true,
    };
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/FetchSlots/",
      payload
    );
    // return this.http.post<any>(
    //   environment.apiUrl +
    //     "HMS/GetAvailableSlotsByDate?center_id=" +
    //     hospitalId +
    //     "&doctor_id=" +
    //     doctorId +
    //     "&appointmentDate=" + // <-- fixed here
    //     apptDate,
    //   "" // <-- required empty body
    // );
  }

  BookConsultationAppointment(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/BookConsultationAppointment/",
      payload
    );
  }
  getAppointmentsHistoryOnMobileNumber(payload: any) {
    return this.http.post<any>(
      environment.apiUrl +
        "LeadsManagement/FetchAppointmentsHistoryOnMobileNumber/",
      payload
    );
  }
  getAppointmentsHistoryOnMobileNumberFromAskApollo(payload: any) {
    return this.http.post<any>(
      environment.apiUrl +
        "AskApollo/GetAppointmentHistoryOnMobileNumberFromAskApollo/",
      //"AskApollo/GetConsultAppointmentHistoryOnMobileNumber/",

      payload
    );
  }
  RescheduleAppointment(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/RescheduleAppointment/",
      payload
    );
  }
  CancelAppointment(payload: any) {
    //debugger;
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/CancelAppointment/",
      payload
    );
  }
  InsertGeneralEnquiryDetails(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/InsertGeneralEnquiryDetails/",
      payload
    );
  }

  UpdateCallerStatus(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/UpdateCallerEnquiryDetails/",
      payload
    );
  }

  UpdateConfirmedAppointmentStatusEIH(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "AskApollo/UpdateConfirmedAppointmentStatusEIH/",
      payload
    );
  }
  AddAIHistory(payload: any) {
    return this.http.post<any>(
      environment.apiUrl + "UserManagement/AddAIHistory",
      payload
    );
  }
  GetAiHistory() {
    return this.http.get<any>(
      environment.apiUrl + "UserManagement/GetAIHistory"
    );
  }
}
